@if(!isAuthenticated) {
<app-public-header></app-public-header>
}

<div class="container pb-50 pt-70" id="profile-tabs">
    <div class="tab-content" id="profileTabContent">
        <div class="tab-pane fade show active" id="personal" role="tabpanel" aria-labelledby="personal-tab">
            <!-- Personal information content here -->
            <div class="card mt-15 px-20">
                <div class="row">
                    <div class="col-md-12 col-lg-12 d-flex">
                        <div class="pic-and-check ml-0">
                            <div class="pic-and-check ml-0">
                                <img alt="img" [src]="
                    profileData?.meta.profile_image
                      ? profileData?.meta.profile_image
                      : '../../../../assets/images/teacher-static-profile.png'
                  " class="profile-picture img-complete-match" />
                            </div>
                        </div>
                        <div class="pic-and-check ml-10">
                            <div class="d-flex">
                                <p>
                                    <a role="button" aria-label="Teacher Profile Info" class="user-title fs-18">{{
                                        profileData?.user.full_name }}</a>
                                </p>
                            </div>
                            <p class="text-r-18">
                                @if(profileData?.meta?.you_are_a){
                                <span> {{ profileData?.meta.you_are_a }}</span>
                                }

                            </p>
                            <p class="txt-regular">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    stroke-width="1" class="bi bi-telephone" viewBox="0 0 15 19">
                                    <path
                                        d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                </svg>
                                {{ profileData?.phone }}
                                <span class="divider-right ml-3 mr-5"> </span>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" fill="currentColor"
                                        class="bi bi-person" viewBox="0 0 15 20" stroke-width="1">
                                        <path
                                            d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                                    </svg>
                                    {{ profileData?.user?.email }}
                                </span>
                            </p>
                            <p class="txt-regular"
                                *ngIf="profileData?.address?.city && profileData?.address?.address_timezone?.state">
                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" fill="currentColor"
                                    stroke-width="1" class="bi bi-geo-alt" viewBox="0 0 15 19">
                                    <path
                                        d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                </svg>
                                {{ profileData?.address?.city }},
                                {{ profileData?.address?.address_timezone?.state }}
                            </p>

                        </div>
                    </div>
                </div>
            </div>
            <div class="card px-15 mt-20">
                <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
                    <h1 class="user-title fs-18">Availability to work
                    </h1>
                </div>
                <div class="col-md-12 col-lg-12 mt-15">
                    <!-- Availability to work content here -->
                    <app-inline-calendar from="FNT" [availability]="profileData?.availability">
                    </app-inline-calendar>
                </div>
            </div>
            <!-- <div class="card px-15 mt-16" *ngIf="introVideo?.id">
                <div class="d-flex s_between align-items-center">
                    <div class="d-flex">
                        <h5 class=" ul-title mb-0">Video Introduction
                        </h5>
                    </div>
                </div>

                <ng-container>
                    <div class="row justify-content-center align-items-center text-center p-20">
                        <div class="col-lg-12">
                            <div class="col-lg-12">
                                <app-video-player [videoMeta]="introVideo"></app-video-player>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div> -->
            <div class="card mt-15 px-20">
                <div class="row">
                    <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
                        <h1 class="user-title fs-18">Skills</h1>
                    </div>

                    <div class="col-md-12 col-lg-12 mt-15">
                        <h4 class="text-regular-medium fs-16">Teaching levels</h4>
                        <div class="col-md-12" *ngIf="profileData?.meta?.experiance_tree">
                            <ul class="custom-li-tag  flex-wrap mr-10">
                                @if(profileData?.meta?.experiance_tree.length > 0){
                                <li *ngFor="let levels of profileData?.meta?.experiance_tree">
                                    <span class="levels bg-tags">{{ levels }}</span>
                                </li>
                                } @else{
                                <li class="txt-regular tags mt-5">No levels found</li>
                                }
                            </ul>
                        </div>
                        <div class="col-md-12" *ngIf="!profileData?.meta?.experiance_tree">
                            <p class="txt-regular tags mt-5">No levels found</p>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12 mt-15">
                        <h4 class="text-regular-medium fs-16">Subjects</h4>
                        <div class="col-md-12" *ngIf="profileData?.meta?.tags">
                            <ul class="custom-li-tag flex-wrap">
                                @if(profileData?.meta?.tags.length > 0){
                                <li *ngFor=" let tag of profileData?.meta?.tags">
                                    <span class="qualified-in bg-tags mr-10">{{ tag }}</span>
                                </li>
                                }@else{
                                <li class="txt-regular tags mt-5">No Subjects found</li>
                                }
                            </ul>
                        </div>
                        <div class="col-md-12" *ngIf="!profileData?.meta?.tags">
                            <p class="txt-regular tags mt-5">No Subjects found</p>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-12">
                        <h4 class="text-regular-medium fs-16 mt-15">Employment summary</h4>
                        <div class="" *ngIf="profileData?.meta?.experience_description">
                            <p class="txt-regular mt-5" *ngIf="profileData?.meta?.experience_description.length > 0">
                                {{ profileData?.meta?.experience_description }}
                            </p>
                            <p class="txt-regular mt-5" *ngIf="profileData?.meta?.experience_description.length == 0">
                                No employment summary found
                            </p>
                        </div>
                        <div class="" *ngIf="!profileData?.meta?.experience_description">
                            <p class="txt-regular mt-5">No employment summary found</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-15 px-20">
                <div class="row">
                    <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
                        <h1 class="user-title fs-18">Work experience</h1>
                    </div>

                    <div class="col-md-12 col-lg-12 mt-15">
                        <div class="" *ngIf="profileData?.work_experience">
                            <div *ngIf="profileData?.work_experience?.work_experience?.length > 0">
                                @for (work_experience of
                                profileData?.work_experience.work_experience; track
                                work_experience; let i = $index){
                                <div class="mt-15">
                                    <div class="d-flex align-items-center s_between">
                                        <p class="text-regular-medium fs-16">
                                            {{ work_experience.job_title }}
                                        </p>

                                    </div>
                                    <p class="txt-regular mt-5">
                                        {{ work_experience.school_name }}
                                    </p>
                                    <p class="txt-regular mt-5">
                                        {{ work_experience.from_date }}
                                        -
                                        {{ work_experience.to_date }}
                                    </p>
                                    <p class="txt-regular mt-5">
                                        {{ work_experience.experience_summary }}
                                    </p>
                                </div>
                                <hr>

                                @if(i
                                < profileData?.work_experience?.length - 1) { <hr />
                                } }
                            </div>
                            <div>
                                <p class="txt-regular mt-5" *ngIf="profileData?.work_experience?.length == 0">
                                    No experience found
                                </p>
                            </div>
                        </div>
                        <div class="" *ngIf="!profileData?.work_experience">
                            <p class="txt-regular mt-5">No experience found</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-15 px-20">
                <div class="row">
                    <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
                        <h1 class="user-title fs-18">Qualifications</h1>
                    </div>
                    <div class="col-md-12 col-lg-12 mt-25" *ngIf="profileData?.meta?.qualifications">
                        @for (item of profileData?.meta?.qualifications; track item; let
                        i = $index){
                        <div class="d-flex align-items-center s_between">
                            <h4 class="text-regular-medium fs-16">{{ item.type }}</h4>
                        </div>


                        <p class="txt-regular">{{ item.institution }}</p>
                        @if(item.file ){
                        <a href="{{ item.file }}" target="_self" class="txt-regular a-link underline">View - {{
                            item.type }}</a>
                        }
                        @if(i
                        < profileData?.meta?.qualifications.length - 1) { <hr />
                        } }
                        <div class="col-md-12" *ngIf="!profileData?.meta?.qualifications">
                            <p class="txt-regular tags mt-5">No Qualifications found</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-15 px-20">
                <div class="row">
                    <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
                        <h1 class="user-title fs-18">Additional documents</h1>
                    </div>
                    <div class="col-md-12 col-lg-12 mt-25" *ngIf="profileData?.meta?.attachments">
                        @for (item of profileData?.meta?.attachments; track item; let i
                        = $index){
                        <div class="d-flex align-items-center s_between">
                            <h4 class="text-regular-medium fs-16">{{ item.name }}</h4>
                        </div>
                        <p class="txt-regular">{{ item.description }}</p>
                        @if(item.name){
                        <a href="{{ item.file }}" target="_self" class="txt-regular a-link underline">View - {{
                            item.name }}</a>
                        }@else {
                        <a href="{{ item.file }}" target="_self" class="txt-regular a-link underline">View -
                            Document</a> }
                        @if(i
                        < profileData?.meta?.attachments.length - 1) { <hr />
                        } }
                        <div class="col-md-12" *ngIf="!profileData?.meta?.attachments">
                            <p class="txt-regular tags mt-5">No Additional documents found</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- References content here -->
            <div class="card mt-15 px-20">
                <div class="row">
                    <div class="col-md-12 col-lg-12 d-flex align-items-center s_between">
                        <h1 class="user-title fs-18">References</h1>
                    </div>
                    @if(profileData?.meta?.references &&
                    profileData?.meta?.references.length>0) {
                    <div class="col-md-12 col-lg-12 mt-25">
                        @for (item of profileData?.meta?.references; track item; let i =
                        $index){
                        <div class="d-flex align-items-center s_between">
                            <h4 class="text-regular-medium fs-16">{{ item.name }}</h4>
                        </div>
                        <p class="txt-regular">
                            {{ item?.position }}
                            <span *ngIf="item?.position && item?.org" class="divider-right ml-3 mr-5"> </span>
                            <span>
                                {{ item?.org }}
                            </span>
                        </p>
                        <p class="txt-regular mt-5">
                            <svg *ngIf="item?.phone" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                fill="currentColor" stroke-width="1" class="bi bi-telephone" viewBox="0 0 15 19">
                                <path
                                    d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                            </svg>
                            {{ item?.phone }}
                            <span *ngIf="item?.phone && item?.email" class="divider-right ml-3 mr-5"> </span>
                            <span>
                                <svg *ngIf="item?.email" xmlns="http://www.w3.org/2000/svg" width="14" height="20"
                                    fill="currentColor" class="bi bi-person" viewBox="0 0 15 20" stroke-width="1">
                                    <path
                                        d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                                </svg>
                                {{ item?.email }}
                            </span>
                        </p>
                        @if(i
                        < profileData?.meta?.references.length - 1) { <hr />
                        } }
                        <div class="col-md-12" *ngIf="!profileData?.meta?.references">
                            <p class="txt-regular tags mt-5">No references found</p>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>